import { UnmatchedCptPolicyId, UNMATCHED_CPT_POLICY_OPTIONS } from "../../../utils/integrationConfigData";

interface UnmatchedCptCodesProps {
  value: UnmatchedCptPolicyId;
  defaultProviderLabel: string;
  onChange: (value: UnmatchedCptPolicyId) => void;
}

const UnmatchedCptCodes = ({
  value,
  defaultProviderLabel,
  onChange,
}: UnmatchedCptCodesProps) => {
  return (
    <div className="ic-unmatched-cpt" role="group" aria-labelledby="ic-unmatched-cpt-label">
      <div className="ic-unmatched-cpt-inner">
        <span id="ic-unmatched-cpt-label" className="ic-unmatched-cpt-label">
          Unmatched CPT codes (global):
        </span>

        <div className="ic-unmatched-cpt-options">
          {UNMATCHED_CPT_POLICY_OPTIONS.map((option) => {
            const optionLabel =
              option.id === "route_default"
                ? `${option.label} (${defaultProviderLabel})`
                : option.label;
            const inputId = `unmatched-cpt-${option.id}`;

            return (
              <label key={option.id} className="ic-unmatched-cpt-option" htmlFor={inputId}>
                <input
                  id={inputId}
                  type="radio"
                  name="unmatched-cpt-policy"
                  value={option.id}
                  checked={value === option.id}
                  onChange={() => onChange(option.id)}
                />
                <span>{optionLabel}</span>
              </label>
            );
          })}
        </div>
      </div>

      <p className="ic-unmatched-cpt-hint mb-0">
        Applies when a request includes a CPT/HCPCS code not owned by any
        configured service provider.
      </p>
    </div>
  );
};

export default UnmatchedCptCodes;
